import React from "react";
import Alumni from "../components/Alumni";
import HSLCAchievement from "../components/HSLCAchievement";
import SEOHead from "../components/SEOHead";

export default function Achievements() {
	return (
		<>
			<SEOHead
				title="Academic Achievements - HSLC 100% Pass Rate | Sacred Heart School"
				description="Sacred Heart School Chumoukedima celebrates 100% HSLC pass rate 2025! View our academic achievements, toppers, alumni success stories, and examination results. Proof of excellence in education."
				keywords="HSLC results 2025, 100% pass rate, school toppers, academic achievements, examination results, Sacred Heart School results, Nagaland HSLC, best academic results"
				canonicalUrl="https://sacredheartchumoukedima.com/achievements"
				ogTitle="100% HSLC Pass Rate 2025 - Sacred Heart School Achievements"
				ogDescription="Celebrating outstanding academic performance with 100% HSLC success rate. Meet our top performers and successful alumni."
				ogImage="https://sacredheartchumoukedima.com/assets/images/HSLC2025.jpg"
			/>
			<div className="container mx-auto py-8">
		<h2 className="text-3xl font-bold py-6 text-white bg-theme text-center" style={{ textShadow: "1px 1px 1px rgba(0, 0, 0, 0.5)" }}>Achievements</h2>
		<Alumni />
			<HSLCAchievement />
		</div>
		</>
	)
};